<div class="ikt-ures" *ngIf="hiba">{{ hiba }}</div>

<ng-container *ngIf="irat">
  <ion-card>
    <ion-card-header>
      <ion-card-title>
        <span class="iktszam">{{ irat.iktatoszam }}</span>
        <ion-badge [color]="allapotSzin(irat.allapot)" style="margin-left:8px">{{ irat.allapot }}</ion-badge>
        <ion-badge color="medium" style="margin-left:4px">{{ irat.irany === 'be' ? 'bejövő' : 'kimenő' }}</ion-badge>
        <ion-badge color="danger" *ngIf="irat.ervenytelen" style="margin-left:4px">érvénytelen</ion-badge>
      </ion-card-title>
      <ion-card-subtitle>
        {{ irat.targy }} · ügyirat:
        <a href="javascript:void(0)" (click)="ugyiratra()">{{ irat.ugyirat_iktatoszam }}</a>
        <span *ngIf="irat.konyv_nev"> · {{ irat.konyv_nev }}</span>
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div class="ikt-fejsor">
        <ion-input label="Tárgy" label-placement="stacked" [(ngModel)]="szerkesztes.targy"
                   style="max-width:420px"></ion-input>
        <ion-select label="Ügyintéző" label-placement="stacked" interface="popover"
                    [(ngModel)]="szerkesztes.ugyintezo">
          <ion-select-option value="">– nincs –</ion-select-option>
          <ion-select-option *ngFor="let u of ugyintezok" [value]="u.azonosito">{{ u.nev }}</ion-select-option>
        </ion-select>
        <ion-input label="Határidő" label-placement="stacked" type="date"
                   [(ngModel)]="szerkesztes.hatarido"></ion-input>
        <ion-input label="Hivatkozási szám" label-placement="stacked"
                   [(ngModel)]="szerkesztes.hivatkozasi_szam"></ion-input>
        <ion-input label="Elintézés módja" label-placement="stacked"
                   [(ngModel)]="szerkesztes.elintezes_modja"></ion-input>
        <ion-button size="small" (click)="adatMentes()" [disabled]="irat.ervenytelen">Mentés</ion-button>
      </div>

      <div class="ikt-fejsor">
        <ion-textarea label="Feljegyzés" label-placement="stacked" [autoGrow]="true" rows="2"
                      [(ngModel)]="szerkesztes.szoveg" style="max-width:100%;flex:1 1 100%"></ion-textarea>
      </div>

      <!-- Adatok, amiket nem szerkesztünk: az iktatás ténye -->
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <tbody>
            <tr><th>Partner</th><td>{{ irat.partner_nev || '–' }}</td>
                <th>Partner címe</th><td>{{ irat.partner_cim || '–' }}</td></tr>
            <tr><th>Irat kelte</th><td class="szam">{{ irat.kelte || '–' }}</td>
                <th>Iktatva</th><td class="szam">{{ irat.iktatva }}</td></tr>
            <tr><th>Kiadmányozta</th><td>{{ irat.kiadmanyozo || '–' }}
                  <span class="szam" *ngIf="irat.kiadmanyozva"> ({{ irat.kiadmanyozva }})</span></td>
                <th>Expediálva</th><td class="szam">{{ irat.expedialva || '–' }}</td></tr>
            <tr><th>Adathordozó</th><td>{{ irat.adathordozo }}</td>
                <th>Forrás</th><td>{{ irat.forras || 'kézi rögzítés' }}</td></tr>
          </tbody>
        </table>
      </div>

      <div class="ikt-gombsor">
        <ion-button size="small" color="tertiary" (click)="kiadmanyoz()"
                    [disabled]="irat.ervenytelen || irat.allapot !== 'iktatott'">
          <ion-icon slot="start" name="checkmark-done-outline"></ion-icon>Kiadmányozás
        </ion-button>
        <ion-button size="small" color="secondary" (click)="expedial()"
                    [disabled]="irat.ervenytelen || irat.allapot === 'elintezett'">
          <ion-icon slot="start" name="send-outline"></ion-icon>Expediálás
        </ion-button>
        <ion-button size="small" color="success" (click)="elintez()" [disabled]="irat.ervenytelen">
          <ion-icon slot="start" name="checkmark-outline"></ion-icon>Elintézve
        </ion-button>
        <ion-button size="small" fill="outline" (click)="postara()">
          <ion-icon slot="start" name="mail-outline"></ion-icon>Postakönyvbe
        </ion-button>
        <ion-button size="small" fill="clear" color="danger" (click)="ervenytelenit()"
                    [disabled]="irat.ervenytelen">Érvénytelenítés</ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Csatolmányok -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Csatolt állományok</ion-card-title>
      <ion-card-subtitle>
        A papírról szkennelt másolatnál jelöld be a hitelesítést: ilyenkor a
        Másolatkészítési Szabályzat záradéka is rákerül a nyilvántartásra.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ikt-fejsor">
        <ion-select label="Szerep" label-placement="stacked" interface="popover"
                    [(ngModel)]="feltoltes.szerep">
          <ion-select-option value="fooirat">főirat</ion-select-option>
          <ion-select-option value="melleklet">melléklet</ion-select-option>
          <ion-select-option value="boritek">boríték</ion-select-option>
          <ion-select-option value="kiadmany">kiadmány</ion-select-option>
        </ion-select>
        <ion-select label="Eredeti" label-placement="stacked" interface="popover"
                    [(ngModel)]="feltoltes.eredeti_adathordozo">
          <ion-select-option value="papir">papír</ion-select-option>
          <ion-select-option value="elektronikus">elektronikus</ion-select-option>
        </ion-select>
        <ion-checkbox labelPlacement="end" [checked]="feltoltes.hiteles_masolat"
                      (ionChange)="feltoltes.hiteles_masolat = $event.detail.checked">
          Hiteles másolat
        </ion-checkbox>
        <input type="file" (change)="fajlValasztva($event)" [disabled]="feltoltesFolyamatban"
               style="max-width:280px" />
        <ion-spinner name="crescent" *ngIf="feltoltesFolyamatban"></ion-spinner>
      </div>

      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead>
            <tr><th>Név</th><th>Szerep</th><th>Eredeti</th><th>Hiteles</th><th>Méret</th><th>Művelet</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let cs of csatolmanyok">
              <td>{{ cs.nev }}</td>
              <td>{{ cs.szerep }}</td>
              <td>{{ cs.eredeti_adathordozo }}</td>
              <td>
                <ion-badge color="success" *ngIf="cs.hiteles_masolat" [title]="cs.zaradek">
                  hiteles<span *ngIf="cs.dpi"> · {{ cs.dpi }} dpi</span>
                </ion-badge>
              </td>
              <td class="szam">{{ cs.meret ? (cs.meret / 1024 | number:'1.0-0') + ' kB' : '–' }}</td>
              <td>
                <ion-button size="small" fill="clear" (click)="megnyit(cs)">Megnyitás</ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="csatolmanyTorol(cs)">Levétel</ion-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!csatolmanyok.length">Ehhez az irathoz még nincs csatolt állomány.</div>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Kapcsolatok és postázás -->
  <ion-card *ngIf="kapcsolatok.length || posta.length">
    <ion-card-header><ion-card-title>Kapcsolódások</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="ikt-tabla-doboz" *ngIf="kapcsolatok.length">
        <table class="ikt-tabla">
          <thead><tr><th>Kapcsolat</th><th>Iktatószám</th><th>Tárgy</th></tr></thead>
          <tbody>
            <tr *ngFor="let k of kapcsolatok" (click)="masikIratra(k)" style="cursor:pointer">
              <td>{{ k.tipus }}</td>
              <td class="iktszam">{{ k.masik_iktatoszam }}</td>
              <td>{{ k.masik_targy }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ikt-tabla-doboz" *ngIf="posta.length">
        <table class="ikt-tabla">
          <thead><tr><th>Címzett</th><th>Mód</th><th>Feladva</th><th>Ragszám</th><th>Állapot</th></tr></thead>
          <tbody>
            <tr *ngFor="let p of posta">
              <td>{{ p.cimzett_nev }}</td><td>{{ p.kuldes_mod }}</td>
              <td class="szam">{{ p.feladva || '–' }}</td><td class="szam">{{ p.ragszam || '–' }}</td>
              <td><ion-badge color="medium">{{ p.statusz }}</ion-badge></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Napló -->
  <ion-card>
    <ion-card-header><ion-card-title>Eseménynapló</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Mikor</th><th>Ki</th><th>Mit</th></tr></thead>
          <tbody>
            <tr *ngFor="let e of esemenyek">
              <td class="szam">{{ e.mikor | date:'yyyy-MM-dd HH:mm' }}</td>
              <td>{{ e.ki }}</td><td>{{ e.mit }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!esemenyek.length">Nincs naplóbejegyzés.</div>
      </div>
    </ion-card-content>
  </ion-card>
</ng-container>
